import initHeader from '@/components/header';
import '@/styles/index.scss';

initHeader();
